import { z } from "zod"

export const PriceModeDefaultValues = {
  price_mode: "",
}

export const PriceModeSettingsSchema = z.object({
  price_mode: z.string(),
})

export type PriceModeSettingsType = z.infer<typeof PriceModeSettingsSchema>
